export const percentageMultiply = (value, percentage) =>
  (value * percentage) / 100;

export const valuesMultiply = (firstValue, secondValue) =>
  firstValue * secondValue;

export const calculateQuantity = (maxValue, currentValue) =>
  maxValue / currentValue;
